import { useState } from "react";

const TESTIMONIALS = [
  {
    stars: 5,
    text: "Cafe dekorasyonumuzu VİP Reklam yaptı. Beklentilerimizin çok üzerinde bir sonuç elde ettik. Müşterilerimiz dekorasyonumuzu çok beğeniyor, teşekkür ederiz.",
    name: "Ayşe Demir",
    role: "Kemal Pastanesi · Kurucu Ortak",
    initial: "A",
  },
  {
    stars: 5,
    text: "Cephe kaplamamızı VİP Reklam ekibi gerçekleştirdi. Hem işçilik kalitesi hem de kullanılan malzemeler mükemmeldi. Kesinlikle tavsiye ederim.",
    name: "Mehmet Yılmaz",
    role: "Lavas Center · Genel Müdür",
    initial: "M",
  },
  {
    stars: 5,
    text: "LED tabela çalışması için VİP Reklam'ı tercih ettik. Tasarım sürecinden montaja kadar her şey çok profesyoneldi.",
    name: "Fatma Kaya",
    role: "Kepirler Market · Sahibi",
    initial: "F",
  },
  {
    stars: 5,
    text: "Çocuk oyun alanı dekorasyonumuzda harika bir iş çıkardılar. Çocuklar ve veliler çok memnun, sürekli olumlu geri bildirimler alıyoruz.",
    name: "Hasan Çelik",
    role: "CarnevalKids · Kurucu",
    initial: "H",
  },
  {
    stars: 5,
    text: "Reklam tabelamızın tasarım ve üretimini VİP Reklam üstlendi. Renk ve kalite açısından tam istediğimiz gibi oldu.",
    name: "Zeynep Arslan",
    role: "Bakraç Cafe · İşletme Ortağı",
    initial: "Z",
  },
];

const COUNTER_STATS = [
  { value: "%98", label: "Memnuniyet" },
  { value: "300+", label: "Marka" },
  { value: "1577+", label: "Proje" },
  { value: "18", label: "Şehir" },
];

const TestimonialsSection = () => {
  const [current, setCurrent] = useState(1);

  const prev = () => setCurrent((c) => (c - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setCurrent((c) => (c + 1) % TESTIMONIALS.length);
  const t = TESTIMONIALS[current];

  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-16 anim-up">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-[3px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">
              Referanslar
            </span>
          </div>
          <h2 className="font-head font-black uppercase text-[#0D0D0D] text-6xl md:text-7xl leading-[0.9]">
            Müşteri
            <br />
            <span className="text-[#E6A800]">Görüşleri</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_300px] gap-8 anim-up d1">
          {/* Main review */}
          <div className="relative bg-[#F7F7F7] p-8 md:p-10 border-l-4 border-[#C62828] overflow-hidden">
            <div className="absolute top-4 right-6 font-head font-black text-[#E8E8E8] text-[120px] leading-none select-none pointer-events-none">
              "
            </div>
            <div className="flex items-center gap-1 mb-5">
              {Array.from({ length: t.stars }).map((_, i) => (
                <i key={i} className="ri-star-fill text-[#E6A800] text-sm" />
              ))}
            </div>
            <p className="font-head text-[#0D0D0D] text-xl md:text-2xl font-500 leading-snug mb-8 italic relative z-10">
              "{t.text}"
            </p>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#E6A800] text-white font-head font-black text-base">
                  {t.initial}
                </div>
                <div>
                  <div className="text-[#0D0D0D] font-head font-700 uppercase text-sm tracking-wide">
                    {t.name}
                  </div>
                  <div className="text-[#737373] text-xs">{t.role}</div>
                </div>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={prev}
                  className="w-9 h-9 flex items-center justify-center bg-white border border-[#E8E8E8] text-[#737373] hover:bg-[#E6A800] hover:text-white hover:border-[#C62828] tr cursor-pointer"
                  aria-label="Önceki yorum"
                >
                  <i className="ri-arrow-left-line text-sm" />
                </button>
                <button
                  onClick={next}
                  className="w-9 h-9 flex items-center justify-center bg-[#E6A800] text-white hover:bg-[#B71C1C] tr cursor-pointer"
                  aria-label="Sonraki yorum"
                >
                  <i className="ri-arrow-right-line text-sm" />
                </button>
              </div>
            </div>
            <div className="flex gap-1.5 mt-5">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`h-[3px] tr cursor-pointer ${
                    i === current ? "w-6 bg-[#E6A800]" : "w-3 bg-[#E8E8E8]"
                  }`}
                  aria-label={`Yorum ${i + 1}`}
                />
              ))}
            </div>
          </div>

          {/* Stats card */}
          <div className="bg-[#0D0D0D] p-8 flex flex-col justify-between">
            <div>
              <p className="text-[#E6A800] text-xs font-head font-700 uppercase tracking-[0.2em] mb-4">
                Rakamlarla Biz
              </p>
              <h3 className="font-head font-black uppercase text-white text-3xl leading-tight mb-6">
                Müşteri
                <br />
                Memnuniyeti
              </h3>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {COUNTER_STATS.map((s) => (
                <div
                  key={s.label}
                  className="bg-white/5 border border-white/10 p-4 hover:border-[#C62828]/50 tr"
                >
                  <div className="font-head font-black text-[#E6A800] text-3xl leading-none">
                    {s.value}
                  </div>
                  <div className="text-white/40 text-xs font-head uppercase tracking-wider mt-1">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;